import { render, staticRenderFns } from "./LoanDeliveredDetail.vue?vue&type=template&id=20aebd9c&"
import script from "./LoanDeliveredDetail.vue?vue&type=script&lang=js&"
export * from "./LoanDeliveredDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanDeliveredDetail.vue?vue&type=style&index=0&id=20aebd9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports